import React, { useState } from "react";
import { Link } from "react-router-dom";

const MobileMenu = ({ mobileMenu, handleMobileMenu }) => {
  const [activeSubmenu, setActiveSubmenu] = useState(null);

  // Function to toggle submenu
  const toggleSubmenu = (menu) => {
    setActiveSubmenu(activeSubmenu === menu ? null : menu);
  };
  return (
    <div className={mobileMenu ? "mobile-nav" : "mobile-nav show"}>
      <button onClick={handleMobileMenu} type="button" className="close-nav">
        <i className="fal fa-times-circle"></i>
      </button>
      <nav className="sidebar-nav">
        <ul className="metismenu" id="mobile-menu">
          <li>
            <Link to="/">Home</Link>
            {/* <ul className="sub-menu">
                        <li><Link to="/">homepage 1</Link></li>
                        <li><Link to="/homeTwo">homepage 2</Link></li>
                        <li><Link to="/homeThree">homepage 3</Link></li>
                        <li><Link to="/homeFour">homepage 4</Link></li>
                    </ul> */}
          </li>
          <li>
            <Link to="/about">
              about us{" "}
             
               <i
                className={`fal ${
                  activeSubmenu === "about"
                    ? "fa-chevron-up"
                    : "fa-chevron-down"
                }`}
                onClick={() => toggleSubmenu("about")}
              ></i>

            </Link>
            {activeSubmenu === "about" && (
              <ul className="sub-menu">
                <li>
                  <Link to="/history">History</Link>
                </li>
                <li>
                  <Link to="/misson_vision">Misson & Vision</Link>
                </li>
                <li>
                  <Link to="/Corporate_Value">Corporate Value</Link>
                </li>
                <li>
                  <Link to="/warehouse">Gold Coin Warehousing </Link>
                </li>
              </ul>
            )}
          </li>
          <li>
            <Link to="/companyprofile">
              Company Profile{" "}
             
                <i
                className={`fal ${
                  activeSubmenu === "companyprofile"
                    ? "fa-chevron-up"
                    : "fa-chevron-down"
                }`}
                onClick={() => toggleSubmenu("companyprofile")}
              ></i>
            </Link>
            {activeSubmenu === "companyprofile" && (
              <ul
                className="sub-menu"
                style={{
                  width: "300px",
                }}
              >
                <li>
                  <Link to="/Chairmain">Chairmain Message</Link>
                </li>
                <li>
                  <Link to="/Management">Management</Link>
                </li>
                <li>
                  <Link to="/acc_nd_rec">Accreditation & Recognition</Link>
                </li>
                <li>
                  <Link to="/Memberships">Memberships</Link>
                </li>
              </ul>
            )}
          </li>
          <li>
            <Link to="/products">
              Our Products{" "}
              <i
                className={`fal ${
                  activeSubmenu === "products"
                    ? "fa-chevron-up"
                    : "fa-chevron-down"
                }`}
                onClick={() => toggleSubmenu("products")}
              ></i>
            </Link>
            {activeSubmenu === "products" && (
              <ul className="sub-menu">
                <li>
                  <Link to="/raw_cotton">Raw Cotton</Link>
                </li>
                <li>
                  <Link to="/ConsumerEdibleOils">Consumer Edible Oils</Link>
                </li>
                <li>
                  <Link to="/CommercialOils">Commercial Oils</Link>
                </li>
                <li>
                  <Link to="/OilCakes">Oil Cakes (Cattle Feeds)</Link>
                </li>
                <li>
                  <Link to="/OilMeals">
                    Oil Meals (Solvent Extracted De-Oiled Cakes)
                  </Link>
                </li>
                <li>
                  <Link to="/Seeds">Oil seeds / Grains / Pulses</Link>
                </li>
                <li>
                  <Link to="/CottonYarns">Cotton Yarns</Link>
                </li>
              </ul>
            )}
          </li>
          <li>
            <Link to="/Inquiry">Inquiry</Link>
          </li>
          <li>
            <Link to="/Gallery">Gallery</Link>
          </li>
          <li>
            <Link to="/contact">Contact</Link>
          </li>
        </ul>
      </nav>

      {/* <div className="action-bar">
        <a href="mailto:info@example.com">
          <i className="fal fa-envelope"></i> info@shreegita.com
        </a>
        <a href="tel:123-456-7890">
          <i className="fal fa-phone"></i>+91-2822–250345/250246/250231/250059
        </a>
        <Link to="/contact" className="d-btn theme-btn">
          Contact Us
        </Link>
      </div> */}
    </div>
  );
};

export default MobileMenu;
